<template>
    <div class="container-fluid">
      <!-- OPTION :: เลือกภาษาสำหรับ Caption ของแบบฟอร์ม -->
      <div class="row mb-1">
        <div class="col-sm-4 pe-3">
          <div class="input-group input-group-sm">
              <div class="input-group-prepend">
                <span class="input-group-text" style="width:108px;">CAPTION* :</span>
              </div>
              <!-- ให้พิมพ์ Caption TH หรือ EN -->
              <select class="form-select form-select-sm" ref="captionTH_EN" id="captionTH_EN" name="captionTH_EN" v-model="captionTH_EN">
                  <option value="TH" selected>TH - ภาษาไทย</option>
                  <option value="EN">EN - ภาษาอังกฤษ</option>
              </select>
          </div>
        </div>
      </div>
      <!-- ตารางรายการ -->
      <div class="row">
        <div class="col-sm bg-light border py-2">
            <table id="myLabReqTable" class="table table-sm table-hover table-striped table-bordered" style="width: 100%;">
                <thead class="text-white" style="background:Navy">
                <tr>
                    <th>ยกเลิก</th>
                    <th>PAID</th>
                    <th>สถานะ</th>
                    <th>ชื่อสาขา</th>
                    <th>เลขที่ใบตรวจ</th>
                    <th>วันที่</th>
                    <th>ชื่อ-สกุล คนไข้</th>
                    <th>เพศ</th>
                    <th>หน่วยงาน/บริษัท</th>
                    <th>ชำระโดย</th>
                    <th style="width:100px;">สุทธิ</th>
                    <th>คำสั่ง</th>
                    <th>ประเภทการตรวจ</th>
                    <th class="bg-danger">เลขที่ใบเสร็จ</th>
                    <th class="bg-danger">วันที่ใบเสร็จ</th>
                </tr>
                </thead>
                <tbody>
                    <tr v-for="item in datalists" :key="item.ROID" v-bind:data-id="item.ROID" @click="tableChanged(item, $event)">
                        <td class="text-danger"><b> {{ arrCancel[item.Cancel] }}</b></td>
                        <td class="text-primary"><b> {{ arrPaid[item.Paid] }}</b></td>
                        <td class="">
                          <button id="btnGroupDrop1" type="button"
                              class="btn btn-outline btn-sm dropdown-toggle p-0" data-bs-toggle="dropdown" aria-expanded="false">
                              {{ arrDocStatus[item.Status] }}
                          </button>
                          <ul class="dropdown-menu pe-3" aria-labelledby="btnGroupDrop1">
                            <li class="mx-2 bg-danger text-white dropdown-item" @click="cancelRecord(item)" v-if="item.Cancel==0" title="การยกเลิกใบเสร็จ จะทำให้ไม่สามารถเข้าถึงเอกสารได้"> Cancel </li>
                          </ul>
                        </td>
                        <td class="text-start">{{ item.BranchName }}</td>
                        <td class="text-start">{{ item.RONo }}</td>
                        <td class="text-start">{{ item.DocDate }} {{item.DocTime}}</td>
                        <td class="text-start">{{ item.PatName }} {{ item.PatLName}}</td>
                        <td class="">{{ arrSex[item.Sex] }}</td>
                        <td class="text-start"><b> {{ item.ReqClinicName }} </b></td>
                        <td class="text-start">{{ arrPayType[item.PayType] }}</td>
                        <td class="text-end text-primary"><b>{{  numeralFormat(item.NetAmt, '0,0[.]00') }}</b></td>
                        <td class="text-end">
                            <button type="button" class="btn btn-outline-info btn-sm mx-1" v-if="item.Cancel==0"
                              id="Edit" @click="editRecord(item)" title="แสดงรายละเอียด">View</button>
                        </td>
                        <td class="text-start">{{ item.Test }}</td>
                        <td class="text-start">
                            <button type="button" class="btn btn-primary btn-sm mx-1" v-if="item.Cancel==0 && item.RcptID==0"
                              id="Edit" title="บันทึกรับชำระเงินโดยการระบุเลขที่ใบเสร็จให้กับรายการนี้" data-bs-toggle="modal" data-bs-target="#rcptPaymentModal" >เลือกใบเสร็จ</button>
                            {{ item.RcptNo }}
                            <button id="Print" type="button" v-if="item.RcptID>0" class="btn btn-outline-danger btm-sm ms-2 py-0"
                              title="พิมพ์ใบเสร็จรับเงิน" @click="printReceipt(item)"><i class="fa fa-print"></i></button>
                        </td>
                        <td class="text-start">{{ item.DocDateRcpt }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
      </div>
    </div>
    <!-- Modal รับชำระเงินโดย.. -->
    <div id="rcptPaymentModal" class="modal" tabindex="-1">
        <div class="modal-dialog modal-xl">
        <div class="modal-content">
            <div class="modal-header">
            <h5 class="modal-title">Payment | เลือกใบเสร็จที่รับชำระแล้ว</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <div class="row">
                  <div class="col-sm">
                      <!-- วันที่ใบสั่งตรวจ -->
                      <div class="input-group input-group-sm mb-1">
                      <div class="input-group-prepend">
                          <span class="input-group-text" style="width:120px;">วันที่เอกสาร</span>
                      </div>
                      <v-date-picker mode="date" v-model="dateFm" :masks="masks" title="วันที่เอกสารเริ่มต้น">
                          <template v-slot="{ inputValue, inputEvents }">
                              <input name="dateFm" ref="dateFm" style="width:120px;"
                              class="bg-white border px-2 py-1 rounded"
                              :value="inputValue"
                              v-on="inputEvents"
                              />
                          </template>
                      </v-date-picker>
                      <v-date-picker mode="date" v-model="dateTo" :masks="masks" title="วันที่เอกสารสิ้นสุด">
                            <template v-slot="{ inputValue, inputEvents }">
                              <input name="dateTo" ref="dateTo" style="width:120px;"
                              class="bg-white border px-2 py-1 rounded"
                              :value="inputValue"
                              v-on="inputEvents"
                              />
                            </template>
                      </v-date-picker>
                        <button type="button" class="btn btn-info btn-sm text-white mx-2" @click="refreshReceipt()">ดึงข้อมูล</button>
                      </div>
                  </div>
                </div>
                <LabPaidCredit3Payment :key="countRefreshPayment"
                :rowEdit="curRecord" :dateFm="dateFm" :dateTo="dateTo"
                 @onBackPageAfterSaveEvent="backPageAfterSave">></LabPaidCredit3Payment>
            <!-- <LabPaid3Payment :datalists="datalists" :key="countRefresh"
                @onEditRecordEvent="editRecord"
                @onBackPageAfterSaveEvent="backPageAfterSave"></LabPaid3Payment> -->
            </div>

            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" ref="btnCloseModal">Close</button>
            </div>
        </div>
        </div>
    </div>

    <!--  PRINT : RECEIPT PDF -->
    <img id="imageid" ref="imageid" hidden crossorigin="anonymous" v-bind:src="require('../assets/' +  globalCorpInfo.logoFile ) + '?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940'">
    <div id="divToPrint_MasterDtl" hidden>
      <table style="width:100%" data-pdfmake="{'headerRows': 1, 'layout':'lightHorizontalLines'}">
          <thead>
          <tr>
              <th style="width:330px; text-align: center;"><span v-if="this.captionTH_EN === 'TH'">รายการ</span> <span v-else>Description</span> </th>
              <th style="width:100px; text-align: right;" ><span v-if="this.captionTH_EN === 'TH'">ราคาต่อหน่วย</span> <span v-else>Unit Price</span></th>
              <th style="width:100px; text-align: right;" ><span v-if="this.captionTH_EN === 'TH'">จำนวน</span> <span v-else>Qty</span></th>
              <th style="width:140px; text-align: right;" ><span v-if="this.captionTH_EN === 'TH'">เป็นจำนวนเงิน</span> <span v-else>Amount</span></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, index) in reportDtl" :key="index">
              <td >{{ item.ItemDesc }}</td>
              <td style="text-align: right;">{{ formatFloat(item.UnitPrice) }}</td>
              <td style="text-align: right;">{{ formatFloat(item.Qty) }}</td>
              <td style="text-align: right;">{{ formatFloat(item.Amt) }}</td>
          </tr>
          </tbody>
      </table>
    </div>
</template>

<script>
import LabPaidCredit3Payment from './LabPaidCredit3Payment.vue'
// import axios from 'axios'
import { MyApiClient } from '../myjs/my-api-client.js'
// Bootstrap and jQuery libraries
import 'bootstrap/dist/css/bootstrap.min.css'
import 'jquery/dist/jquery.min.js'
// Datatable Modules
import 'datatables.net-dt/js/dataTables.dataTables'
import 'datatables.net-dt/css/jquery.dataTables.min.css'
import $ from 'jquery'
import Swal from 'sweetalert2'
import { inject, ref } from 'vue'
// import JsBarcode from 'jsbarcode/bin/JsBarcode'
import { bahttext } from 'bahttext'

import pdfMake from 'pdfmake'
import pdfFonts from 'pdfmake/build/vfs_fonts'
import htmlToPdfmake from 'html-to-pdfmake'
pdfMake.vfs = pdfFonts.pdfMake.vfs
// // ต้องระบุตามชื่อของ ไฟล์ font
pdfMake.fonts = {
  THSarabunNew: {
    normal: 'THSarabunNew.ttf',
    bold: 'THSarabunNew-Bold.ttf',
    italics: 'THSarabunNew-Italic.ttf',
    bolditalics: 'THSarabunNew-BoldItalic.ttf'
  },
  Roboto: {
    normal: 'Roboto-Regular.ttf',
    bold: 'Roboto-Medium.ttf',
    italics: 'Roboto-Italic.ttf',
    bolditalics: 'Roboto-MediumItalic.ttf'
  }
}
// ----- จัด Format จำนวนเงิน ----- //
const { FormatMoney } = require('format-money-js')
const fm = new FormatMoney({
  decimals: 2
})
// แปลงจำนวนเงินเป็นตัวอักษร
const numberToText = require('number-to-text')
require('number-to-text/converters/en-us')

export default {
  setup () {
    var globalCorpID = inject('corpID', ref(-1))
    var globalCorpName = inject('corpName', ref(''))
    var globalBranchID = inject('branchID', ref(-1))
    var globalUserID = inject('userID', ref(-1))
    var globalUserName = inject('userName', ref(''))
    var globalUserOfficialName = inject('userOfficialName', ref(''))
    var globalUserPosition = inject('userPosition', ref(''))
    var globalCorpInfo = inject('corpInfo', {})
    return {
      globalCorpID, globalCorpName, globalBranchID, globalUserID, globalUserName, globalUserOfficialName, globalUserPosition, globalCorpInfo
    }
  },
  name: 'LabPaid1View',
  data () {
    return {
      captionTH_EN: 'TH',
      // Modal ใบเสร็จ
      dateFm: new Date(),
      dateTo: new Date(),
      countRefreshPayment: 0,

      arrCancel: ['', 'C'],
      arrPaid: ['', 'P'],
      arrSex: ['', 'ชาย', 'หญิง'],
      arrDocStatus: ['New', 'Lab', 'Resulted', 'AP'],
      arrPayType: ['เงินสด', 'เครดิต'],
      curRecord: {},

      reportDtl: null,
      reportHd: null
    }
  },
  props: ['datalists'],
  mounted () {
    // document.addEventListener('DOMContentLoaded', function () {
    //   // INSERT CODE HERE
    // })
  },
  components: {
    LabPaidCredit3Payment
  },
  methods: {
    // modal ใบเสร็จ : กดปุ่มดึงรายการใบเสร็จ
    refreshReceipt () {
      this.countRefreshPayment++
    },
    rowClicked (e) {
      // Activate the 'selected' class on clicking the rows
      // $(e.id).toggleClass('selected')
      console.log(e.target.parentNode.rowIndex)
    },
    // แปลงไฟล์รูปภาพเป็น Base64 Image
    getBase64Image (img) {
      var canvas = document.createElement('canvas')
      canvas.width = img.width
      canvas.height = img.height
      var ctx = canvas.getContext('2d')
      ctx.drawImage(img, 0, 0)
      var dataURL = canvas.toDataURL('image/png')
      return dataURL
    },
    formatFloat (Amt) {
      return fm.from(parseFloat(Amt), { symbol: '' })
    },
    // ----------- (I.) รูปแบบใบเสร็จ (General) ---------- //
    // createPdfReceiptToScreen () {
    //   // ==================================== //
    //   var logoBase64 = this.getBase64Image(this.$refs.imageid)
    //   var self = this
    //   // -------- get table html
    //   const pdfTable = document.getElementById('divToPrint_MasterDtl')
    //   // ------- html to pdf format
    //   var html = htmlToPdfmake(pdfTable.innerHTML, { tableAutoSize: true })
    //   var documentDefinition = {
    //     pageSize: 'A5',
    //     // pageOrientation: 'portrait',
    //     pageOrientation: 'landscape',
    //     pageMargins: [20, 140, 20, 180],
    //     header: {
    //       margin: [20, 10, 20, 5],
    //       table: {
    //         widths: [50, 290, 60, 120],
    //         body: [
    //           [
    //             // Header ซ้าย โลโก้คลินิก
    //             {
    //               rowSpan: 3,
    //               image: logoBase64,
    //               width: 50,
    //               alignment: 'center',
    //               margin: [0, 0, 0, 0]
    //             },
    //             // Header กลาง ชื่อคลินิก
    //             {
    //               text: self.globalCorpInfo.name,
    //               bold: true,
    //               fontSize: 16,
    //               lineHeight: 0.5
    //               // fillColor: '#eeeeee'
    //             },
    //             // Header ด้านขวา ใบสั่งตรวจ
    //             {
    //               rowSpan: 3,
    //               colSpan: 2,
    //               text: 'ใบเสร็จรับเงิน\nRECEIPT',
    //               bold: true,
    //               fontSize: 18,
    //               alignment: 'center',
    //               margin: [10, 10, 0, 0],
    //               lineHeight: 0.8,
    //               fillColor: '#bfbfbf',
    //               border: [0, 0, 0, 0]
    //             },
    //             {}
    //           ],
    //           [
    //             {},
    //             {
    //               text: self.globalCorpInfo.name2,
    //               bold: true,
    //               fontSize: 12,
    //               lineHeight: 0.5
    //               // fillColor: '#eeeeee'
    //             },
    //             {},
    //             {}
    //           ],
    //           [
    //             {},
    //             {
    //               text: self.globalCorpInfo.addr1 + ' ' + self.globalCorpInfo.addr2 + ' ' + self.globalCorpInfo.tambol + ' ' +
    //                     self.globalCorpInfo.amphor + ' ' + self.globalCorpInfo.province + ' ' + self.globalCorpInfo.zipcode + '\n' +
    //                     'Tel: ' + self.globalCorpInfo.tel1 + ' ' + self.globalCorpInfo.tel2 + ' Fax: ' + self.globalCorpInfo.fax + '\n' +
    //                     'Email: ' + self.globalCorpInfo.email1 + ' ' + self.globalCorpInfo.email2,
    //               bold: false,
    //               fontSize: 12,
    //               lineHeight: 0.7
    //               // fillColor: '#eeeeee'
    //             },
    //             {},
    //             {}
    //           ],
    //           [
    //             {
    //               text: 'ได้รับเงินจาก ',
    //               bold: false,
    //               fontSize: 14
    //             },
    //             {
    //               text: self.reportHd.CustName,
    //               bold: false,
    //               fontSize: 14
    //             },
    //             { text: 'เลขที่ใบเสร็จ : ' },
    //             { text: self.reportHd.RcptNo }
    //           ],
    //           [
    //             {
    //               text: 'ที่อยู่ ',
    //               bold: false,
    //               fontSize: 14
    //             },
    //             {
    //               text: self.reportHd.CustAddr,
    //               bold: false,
    //               alignment: 'left',
    //               fontSize: 14
    //             },
    //             { text: 'วันที่ : ' },
    //             { text: self.reportHd.DocDate + ' ' + self.reportHd.DocTime }
    //           ],
    //           [
    //             { },
    //             {
    //               text: 'เลขประจำตัวผู้เสียภาษี : ' + self.reportHd.CustTaxID,
    //               bold: false,
    //               alignment: 'right',
    //               fontSize: 14
    //             },
    //             { },
    //             { }
    //           ]
    //         ]
    //       },
    //       layout: {
    //         defaultBorder: false
    //       }
    //     },
    //     footer: function (currentPage, pageCount) {
    //       return {
    //         margin: [20, 0, 20, 5],
    //         table: {
    //           widths: [130, 130, 130, 130],
    //           body: [
    //             [
    //               {
    //                 text: '',
    //                 border: [0, 1, 0, 0],
    //                 lineHeight: 0.5,
    //                 alignment: 'left'
    //               },
    //               {
    //                 text: '',
    //                 border: [0, 1, 0, 0],
    //                 lineHeight: 0.5,
    //                 alignment: 'left'
    //               },
    //               {
    //                 text: 'รวมเป็นจำนวนเงิน',
    //                 border: [0, 1, 0, 0],
    //                 lineHeight: 0.5,
    //                 alignment: 'right'
    //               },
    //               {
    //                 text: fm.from(parseFloat(self.reportHd.TotalAmt), { symbol: '' }),
    //                 // text: self.reportHd.TotalAmt,
    //                 border: [0, 1, 0, 0],
    //                 lineHeight: 0.5,
    //                 alignment: 'right'
    //               }
    //             ],
    //             [
    //               {
    //                 text: '',
    //                 border: [0, 0, 0, 0],
    //                 lineHeight: 0.5,
    //                 alignment: 'left'
    //               },
    //               {
    //                 text: '',
    //                 border: [0, 0, 0, 0],
    //                 lineHeight: 0.5,
    //                 alignment: 'left'
    //               },
    //               {
    //                 text: 'ส่วนลด   ' + self.reportHd.DiscRate + '%',
    //                 border: [0, 0, 0, 0],
    //                 lineHeight: 0.5,
    //                 alignment: 'right'
    //               },
    //               {
    //                 text: fm.from(parseFloat(self.reportHd.DiscAmt), { symbol: '' }),
    //                 // text: self.reportHd.DiscAmt,
    //                 border: [0, 0, 0, 0],
    //                 lineHeight: 0.5,
    //                 alignment: 'right'
    //               }
    //             ],
    //             [
    //               { text: '', border: [0, 0, 0, 0], lineHeight: 0.5 },
    //               { text: '', border: [0, 0, 0, 0], lineHeight: 0.5 },
    //               {
    //                 text: 'ภาษีมูลค่าเพิ่ม   ' + self.reportHd.VatRate + '%',
    //                 border: [0, 0, 0, 0],
    //                 lineHeight: 0.5,
    //                 alignment: 'right'
    //               },
    //               {
    //                 text: fm.from(parseFloat(self.reportHd.VatAmt), { symbol: '' }),
    //                 // text: self.reportHd.VatAmt,
    //                 border: [0, 0, 0, 0],
    //                 lineHeight: 0.5,
    //                 alignment: 'right'
    //               }
    //             ],
    //             [
    //               {
    //                 text: '(' + bahttext(self.reportHd.NetAmt) + ')',
    //                 colSpan: 2,
    //                 border: [0, 0, 0, 1],
    //                 fillColor: '#eeeeee',
    //                 fontSize: 12,
    //                 alignment: 'center'
    //               },
    //               { },
    //               {
    //                 text: 'จำนวนเงินสุทธิ ',
    //                 border: [0, 0, 0, 1],
    //                 alignment: 'right'
    //               },
    //               {
    //                 text: fm.from(parseFloat(self.reportHd.NetAmt), { symbol: '' }),
    //                 bold: true,
    //                 border: [0, 0, 0, 1],
    //                 alignment: 'right'
    //               }
    //             ],
    //             // ชำระเป็น
    //             [
    //               {
    //                 text: 'ชำระเป็น :  ' + self.reportHd.PaymentName + '   อ้างถึง/เลขที่ : ' + self.reportHd.PaymentRefNo,
    //                 colSpan: 4,
    //                 border: [0, 0, 0, 0],
    //                 alignment: 'left'
    //               },
    //               { },
    //               { },
    //               { }
    //             ],
    //             [
    //               {
    //                 text: '\n\n........................................................................\nผู้รับมอบอำนาจ / Authorized Signature',
    //                 colSpan: 2,
    //                 border: [0, 0, 0, 0],
    //                 alignment: 'center',
    //                 fontSize: 12
    //               },
    //               {},
    //               {
    //                 text: '\n\n........................................................................\nผู้รับเงิน / Collector',
    //                 colSpan: 2,
    //                 border: [0, 0, 0, 0],
    //                 alignment: 'center',
    //                 fontSize: 12
    //               },
    //               {}
    //             ],
    //             [
    //               {
    //                 text: '\n ใบเสร็จรับเงินฉบับนี้จะสมบูรณ์ต่อเมื่อมีลายเซ็นต์ของผู้ได้รับมอบอำนาจและผู้รับเงินลงลายมือชื่อร่วมกัน',
    //                 colSpan: 3,
    //                 border: [0, 0, 0, 0],
    //                 alignment: 'left',
    //                 fontSize: 12
    //               },
    //               { },
    //               { },
    //               {
    //                 text: '\n Page-' + currentPage.toString() + '/' + pageCount.toString() + '\n' + Date(),
    //                 border: [0, 0, 0, 0],
    //                 alignment: 'right',
    //                 fontSize: 12
    //               }
    //             ]
    //           ]
    //         }
    //       }
    //     },
    //     content: html,
    //     style: {
    //       // Document Header
    //       documentHeaderLeft: {
    //         fontSize: 10,
    //         margin: [5, 5, 5, 5],
    //         alignment: 'left'
    //       },
    //       documentHeaderCenter: {
    //         fontSize: 10,
    //         margin: [5, 5, 5, 5],
    //         alignment: 'center'
    //       },
    //       documentHeaderRight: {
    //         fontSize: 10,
    //         margin: [5, 5, 5, 5],
    //         alignment: 'right'
    //       },
    //       // Document Footer
    //       documentFooterLeft: {
    //         fontSize: 6,
    //         margin: [5, 5, 5, 5],
    //         alignment: 'left'
    //       },
    //       documentFooterCenter: {
    //         fontSize: 8,
    //         margin: [5, 5, 5, 5],
    //         alignment: 'center'
    //       },
    //       documentFooterRight: {
    //         fontSize: 8,
    //         margin: [5, 5, 5, 5],
    //         alignment: 'center'
    //       }
    //     },
    //     defaultStyle: {
    //       // font: 'Roboto'
    //       font: 'THSarabunNew',
    //       fontSize: 15,
    //       lineHeight: 0.7
    //     }
    //   }
    //   // pdfMake.vfs = pdfFonts.pdfMake.vfs
    //   pdfMake.createPdf(documentDefinition, 'lightHorizontalLines').open()
    //   // pdfMake.createPdf(documentDefinition).download()
    //   // pdfMake.createPdf(documentDefinition).print()
    // },
    createPdfReceiptToScreen (PgSize, PgOrient) {
      // ==================================== //
      var logoBase64 = this.getBase64Image(this.$refs.imageid)
      var self = this
      // Tel, Fax, Email, TaxID เช็คค่าเพื่อเติมคำนำหน้า
      var strInvcTel = self.globalCorpInfo.InvcTel1 + ' ' + self.globalCorpInfo.InvcTel2
      if (strInvcTel.trim().length > 0) {
        strInvcTel = 'Tel: ' + strInvcTel
      }
      var strInvcFax = self.globalCorpInfo.InvcFax
      if (strInvcFax.trim().length > 0) {
        strInvcFax = 'Fax: ' + strInvcFax
      }
      var strInvcEmail = self.globalCorpInfo.InvcEmail1 + ' ' + self.globalCorpInfo.InvcEmail2
      if (strInvcEmail.trim().length > 0) {
        strInvcEmail = 'Email: ' + strInvcEmail
      }
      var strInvcTaxID = self.globalCorpInfo.InvcTaxID
      if (strInvcTaxID.trim().length > 0) {
        strInvcTaxID = (this.captionTH_EN === 'TH' ? 'เลขประจำตัวผู้เสียภาษี: ' : 'TAX ID.') + strInvcTaxID
      }
      // ข้อความลายน้ำถ้าเอกสารยกเลิก
      var strCANCEL = ''
      if (this.reportHd.Cancel === 1 || this.reportHd.Cancel === '1') {
        strCANCEL = (this.captionTH_EN === 'TH' ? '** ยกเลิก **' : 'CANCELED')
        // strCANCEL = '** ยกเลิก **'
      }
      // -------- get table html
      const pdfTable = document.getElementById('divToPrint_MasterDtl')
      // ------- html to pdf format
      var html = htmlToPdfmake(pdfTable.innerHTML, { tableAutoSize: true })
      var documentDefinition = {
        pageSize: PgSize, // 'A5'
        pageOrientation: PgOrient, // 'landscape'
        // pageOrientation: 'portrait',
        pageMargins: [20, 150, 20, 180],

        watermark: { text: strCANCEL, color: 'red', opacity: 0.8, bold: true, italics: false },
        header: {
          margin: [20, 10, 20, 5],
          table: {
            widths: [50, 290, 60, 120],
            body: [
              [
                // Header ซ้าย โลโก้คลินิก
                {
                  rowSpan: 3,
                  image: logoBase64,
                  width: 50,
                  alignment: 'center',
                  margin: [0, 0, 0, 0]
                },
                // Header กลาง ชื่อคลินิก
                {
                  text: self.globalCorpInfo.InvcName,
                  bold: true,
                  fontSize: 16,
                  lineHeight: 0.5
                  // fillColor: '#eeeeee'
                },
                // Header ด้านขวา ใบสั่งตรวจ
                {
                  rowSpan: 3,
                  colSpan: 2,
                  text: 'ใบเสร็จรับเงิน\nRECEIPT',
                  bold: true,
                  fontSize: 18,
                  alignment: 'center',
                  margin: [10, 10, 0, 0],
                  lineHeight: 0.8,
                  fillColor: '#bfbfbf',
                  border: [0, 0, 0, 0]
                },
                {}
              ],
              [
                {},
                {
                  text: self.globalCorpInfo.InvcName2,
                  bold: true,
                  fontSize: 12,
                  lineHeight: 0.5
                  // fillColor: '#eeeeee'
                },
                {},
                {}
              ],
              [
                {},
                {
                  text: self.globalCorpInfo.InvcAddr1 + ' ' + self.globalCorpInfo.InvcAddr2 + ' ' + self.globalCorpInfo.InvcTambol + ' ' +
                        self.globalCorpInfo.InvcAmphor + ' ' + self.globalCorpInfo.InvcProvince + ' ' + self.globalCorpInfo.InvcZipcode + '\n' +
                        strInvcTel + strInvcFax + '\n' +
                        strInvcEmail + '\n' +
                        strInvcTaxID,
                  bold: false,
                  fontSize: 12,
                  lineHeight: 0.7
                  // fillColor: '#eeeeee'
                },
                {},
                {}
              ],
              [
                {
                  text: (self.captionTH_EN === 'TH' ? 'ได้รับเงินจาก ' : 'Customer '),
                  bold: false,
                  lineHeight: 0.5,
                  fontSize: 14
                },
                {
                  text: self.reportHd.CustName,
                  bold: false,
                  lineHeight: 0.5,
                  fontSize: 14
                },
                { text: (self.captionTH_EN === 'TH' ? 'เลขที่ใบเสร็จ : ' : 'Receipt No. : '), lineHeight: 0.5 },
                { text: self.reportHd.RcptNo, lineHeight: 0.5 }
              ],
              [
                {
                  text: (self.captionTH_EN === 'TH' ? 'ที่อยู่ ' : 'Address '),
                  bold: false,
                  // lineHeight: 0.5,
                  fontSize: 14
                },
                {
                  text: self.reportHd.CustAddr,
                  bold: false,
                  alignment: 'left',
                  // lineHeight: 0.5,
                  fontSize: 14
                },
                { text: (self.captionTH_EN === 'TH' ? 'วันที่ : ' : 'Date : '), lineHeight: 0.5 },
                { text: self.reportHd.DocDate + ' ' + self.reportHd.DocTime, lineHeight: 0.5 }
              ],
              [
                { },
                {
                  text: (self.captionTH_EN === 'TH' ? 'เลขประจำตัวผู้เสียภาษี : ' : 'TAX ID. : ') + self.reportHd.CustTaxID,
                  bold: false,
                  alignment: 'right',
                  lineHeight: 0.5,
                  fontSize: 14
                },
                { },
                { }
              ]
            ]
          },
          layout: {
            defaultBorder: false
          }
        },
        footer: function (currentPage, pageCount) {
          return {
            margin: [20, 0, 20, 5],
            table: {
              widths: [130, 130, 130, 130],
              body: [
                [
                  {
                    text: '',
                    border: [0, 1, 0, 0],
                    lineHeight: 0.5,
                    alignment: 'left'
                  },
                  {
                    text: '',
                    border: [0, 1, 0, 0],
                    lineHeight: 0.5,
                    alignment: 'left'
                  },
                  {
                    text: (self.captionTH_EN === 'TH' ? 'รวมเป็นจำนวนเงิน ' : 'Total '),
                    border: [0, 1, 0, 0],
                    lineHeight: 0.5,
                    alignment: 'right'
                  },
                  {
                    text: fm.from(parseFloat(self.reportHd.TotalAmt), { symbol: '' }),
                    // text: self.reportHd.TotalAmt,
                    border: [0, 1, 0, 0],
                    lineHeight: 0.5,
                    alignment: 'right'
                  }
                ],
                [
                  {
                    text: '',
                    border: [0, 0, 0, 0],
                    lineHeight: 0.5,
                    alignment: 'left'
                  },
                  {
                    text: '',
                    border: [0, 0, 0, 0],
                    lineHeight: 0.5,
                    alignment: 'left'
                  },
                  {
                    text: (self.captionTH_EN === 'TH' ? 'ส่วนลด   ' : 'Disc.   ') + self.reportHd.DiscRate + '%',
                    border: [0, 0, 0, 0],
                    lineHeight: 0.5,
                    alignment: 'right'
                  },
                  {
                    text: fm.from(parseFloat(self.reportHd.DiscAmt), { symbol: '' }),
                    // text: self.reportHd.DiscAmt,
                    border: [0, 0, 0, 0],
                    lineHeight: 0.5,
                    alignment: 'right'
                  }
                ],
                [
                  { text: '', border: [0, 0, 0, 0], lineHeight: 0.5 },
                  { text: '', border: [0, 0, 0, 0], lineHeight: 0.5 },
                  {
                    text: (self.captionTH_EN === 'TH' ? 'ภาษีมูลค่าเพิ่ม   ' : 'VAT   ') + self.reportHd.VatRate + '%',
                    border: [0, 0, 0, 0],
                    lineHeight: 0.5,
                    alignment: 'right'
                  },
                  {
                    text: fm.from(parseFloat(self.reportHd.VatAmt), { symbol: '' }),
                    // text: self.reportHd.VatAmt,
                    border: [0, 0, 0, 0],
                    lineHeight: 0.5,
                    alignment: 'right'
                  }
                ],
                [
                  {
                    text: (self.captionTH_EN === 'TH' ? '(' + bahttext(self.reportHd.NetAmt) + ')' : '(' + numberToText.convertToText(self.reportHd.NetAmt, { case: 'upperCase' }) + ')'),
                    colSpan: 2,
                    border: [0, 0, 0, 1],
                    fillColor: '#eeeeee',
                    fontSize: 12,
                    alignment: 'center'
                  },
                  { },
                  {
                    text: (self.captionTH_EN === 'TH' ? 'จำนวนเงินสุทธิ ' : 'Net Amount   '),
                    border: [0, 0, 0, 1],
                    alignment: 'right'
                  },
                  {
                    text: fm.from(parseFloat(self.reportHd.NetAmt), { symbol: '' }),
                    bold: true,
                    border: [0, 0, 0, 1],
                    alignment: 'right'
                  }
                ],
                // ชำระเป็น
                [
                  {
                    text: (self.captionTH_EN === 'TH' ? 'ชำระเป็น :  ' : 'Payment Method : ') + self.reportHd.PaymentName + (self.captionTH_EN === 'TH' ? '   อ้างถึง/เลขที่ : ' : '   Ref. : ') + self.reportHd.PaymentRefNo,
                    colSpan: 4,
                    border: [0, 0, 0, 0],
                    alignment: 'left'
                  },
                  { },
                  { },
                  { }
                ],
                [
                  {
                    text: '\n\n........................................................................\n' + (self.captionTH_EN === 'TH' ? 'ผู้รับมอบอำนาจ / Authorized Signature' : 'Authorized Signature'),
                    colSpan: 2,
                    border: [0, 0, 0, 0],
                    alignment: 'center',
                    fontSize: 12
                  },
                  {},
                  {
                    text: '\n\n........................................................................\n' + (self.captionTH_EN === 'TH' ? 'ผู้รับเงิน / Collector' : 'Collector'),
                    colSpan: 2,
                    border: [0, 0, 0, 0],
                    alignment: 'center',
                    fontSize: 12
                  },
                  {}
                ],
                [
                  {
                    text: '\n ' + (self.captionTH_EN === 'TH' ? 'ใบเสร็จรับเงินฉบับนี้จะสมบูรณ์ต่อเมื่อมีลายเซ็นต์ของผู้ได้รับมอบอำนาจและผู้รับเงินลงลายมือชื่อร่วมกัน' : ''),
                    colSpan: 3,
                    border: [0, 0, 0, 0],
                    alignment: 'left',
                    fontSize: 12
                  },
                  { },
                  { },
                  {
                    text: '\n Page-' + currentPage.toString() + '/' + pageCount.toString() + '\n' + Date(),
                    border: [0, 0, 0, 0],
                    alignment: 'right',
                    fontSize: 12
                  }
                ]
              ]
            }
          }
        },
        content: html,
        style: {
          // Document Header
          documentHeaderLeft: {
            fontSize: 10,
            margin: [5, 5, 5, 5],
            alignment: 'left'
          },
          documentHeaderCenter: {
            fontSize: 10,
            margin: [5, 5, 5, 5],
            alignment: 'center'
          },
          documentHeaderRight: {
            fontSize: 10,
            margin: [5, 5, 5, 5],
            alignment: 'right'
          },
          // Document Footer
          documentFooterLeft: {
            fontSize: 6,
            margin: [5, 5, 5, 5],
            alignment: 'left'
          },
          documentFooterCenter: {
            fontSize: 8,
            margin: [5, 5, 5, 5],
            alignment: 'center'
          },
          documentFooterRight: {
            fontSize: 8,
            margin: [5, 5, 5, 5],
            alignment: 'center'
          }
        },
        defaultStyle: {
          // font: 'Roboto'
          font: 'THSarabunNew',
          fontSize: 15,
          lineHeight: 0.7
        }
      }
      // pdfMake.vfs = pdfFonts.pdfMake.vfs
      pdfMake.createPdf(documentDefinition, 'lightHorizontalLines').open()
      // pdfMake.createPdf(documentDefinition).download()
      // pdfMake.createPdf(documentDefinition).print()
    },
    getPrintReceiptHdData (RcptID) {
      var self = this
      MyApiClient.get('getdata/receipt_hd_where_id.php?id=' + RcptID)
        .then((resp) => {
          self.reportHd = resp.data.response
          self.createPdfReceiptToScreen()
        })
        .catch((err) => {
          console.log(err.response)
        })
    },
    getPrintReceiptDtlData (RcptID) {
      var self = this
      MyApiClient.get('getdata/receipt_dtl_where_id.php?id=' + RcptID)
        .then((resp) => {
          self.reportDtl = resp.data.response
          self.getPrintReceiptHdData(RcptID)
          // console.log()
        })
        .catch((err) => {
          console.log(err.response)
        })
    },
    printReceipt (row) {
      var RcptID = row.RcptID
      // ดึงข้อมูลให้เสร็จก่อนแล้วค่อยสร้างรายงาน เรียกแบบ promise
      //    getPrintReceiptDtlData() --> getPrintReceiptHdData()
      this.getPrintReceiptDtlData(RcptID)
    },
    // Callback หลังจาก 1-รับชำระเงิน
    backPageAfterSave () {
      // console.log('backPageAfterSave <LabPaid1View>..')
      var elem = this.$refs.btnCloseModal
      elem.click()
      // this.$refs.btnCloseModal.click()
      // ดึงข้อมูลรีเฟรชตารางใบสั่งตรวจ
      this.$emit('onBackPageAfterSaveEvent')
    },
    cancelRecord (item) {
      var self = this
      Swal.fire({
        title: item.RONo,
        text: 'คุณแน่ใจหรือไม่...ที่จะยกเลิกข้อมูล?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ใช่! แน่ใจ',
        cancelButtonText: 'ยกเลิก'
      }).then((result) => {
        if (result.isConfirmed) {
          $.ajax({
            type: 'POST',
            url: this.http_baseurl + 'setdata/cancel_ro.php',
            data: { id: item.ROID },
            error: function (xhr, status, error) {
              Swal.fire({ icon: 'error', text: 'ไม่สามารถยกเลิกข้อมูลได้ ' + error })
            }
          }).done(function () {
            Swal.fire({
              text: 'ข้อมูลของคุณถูกยกเลิกเรียบร้อย',
              icon: 'success',
              confirmButtonText: 'ตกลง'
            }).then((result) => {
              self.$emit('onBackPageAfterSaveEvent')
            })
          })
        }
      })
    },
    editRecord (row) {
      var curRow = Object.assign({}, row)
      this.curRecord = curRow
      this.action = 'edit'
      this.$emit('onEditRecordEvent', this.curRecord)
    },
    tableChanged (row, e) {
      var curRow = Object.assign({}, row)
      this.curRecord = curRow
      this.action = 'edit'
      // console.log(this.curRecord)
      this.countRefreshPayment++

      // คลิก แสดงว่าเลือก --> แสดงแถบไฮไลต์โดยใส่คลาส 'selected' event.target.getAttribute('data-id');
      $(e.target.parentNode).toggleClass('selected')
      var myTable = $('#myLabReqTable').DataTable()
      var totalCount = myTable.rows('.selected').data().length
      console.log(row)
      console.log(e.target.parentNode) // e.target = td, e.target.parentNode = tr
      console.log(e.target.parentNode.rowIndex)
      console.log('จำนวนแถวที่เลือก : ' + totalCount.toString())
      // var trs = $('#myLabReqTable').find('tr')
      var trs = $('.selected')
      console.log(trs)
      // Loop through each tr.
      $(trs).each(function () {
        // Single tr.
        var tr = $(this)
        console.log(tr)
        // console.log($(tr).getAttribute('data-id'))
      })
    }
  }
}
</script>

<style>

</style>
